import style from './footer.module.css';
export default function Footer() {
  return (
    <div className={style.containerFooter}>
        <div>Versión 2.0.0   </div>
        {/* <div>Última sesión el 9/01/2023 a las 10:30 am</div> */}
    </div>
  )
}
